import { api, assetUrl } from './api.config'
import { IBasicInfo } from './generalAsset'

export const getAssetInfo = async (assetId: number, innerCode: string): Promise<IBasicInfo> => {
    const url = `${assetUrl}${api.assetInfo.assetInfo}/${innerCode}/asset/${assetId}`

    return fetch(url, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(fetchData => {
            if (fetchData.ok) {
                return fetchData.json()
            } else if (fetchData.status === 404) {
                return undefined
            } else {
                throw new Error(`{"status": ${fetchData.status} , "message": "${fetchData.statusText}"}`)
            }
        })
        .catch(err => {
            return JSON.parse(err.message)
        })
}

export const postAssetInfo = async (
    assetId: number,
    innerCode: string,
    bodyRequest: IBasicInfo
): Promise<IBasicInfo> => {
    const url = `${assetUrl}${api.assetInfo.assetInfo}/${innerCode}/asset/${assetId}`

    return fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(bodyRequest)
    })
        .then(fetchData => {
            if (fetchData.ok) {
                return fetchData.json()
            } else {
                throw new Error(`{"status": ${fetchData.status} , "message": "${fetchData.statusText}"}`)
            }
        })
        .catch(err => {
            return JSON.parse(err.message)
        })
}

export const patchAssetInfo = async (
    assetId: number,
    innerCode: string,
    bodyRequest: IBasicInfo
): Promise<IBasicInfo> => {
    const url = `${assetUrl}${api.assetInfo.assetInfo}/${innerCode}/asset/${assetId}`
    const [result, err] = await fetch(url, {
        method: 'PATCH',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(bodyRequest)
    })
        .then(fetchData => {
            if (fetchData.ok) {
                return [fetchData.json(), null]
            }

            if (fetchData.status === 500) {
                return fetchData.json().then(bad => {
                    const code = bad.message

                    return [null, code]
                })
            }

            if (fetchData.status === 400) {
                return fetchData.json().then(badRequestBody => {
                    const code = badRequestBody.message

                    return [null, code]
                })
            }
        })
        .catch(err => {
            console.log(err)

            return [null, 'generic_error']
        })

    if (err) {
        throw new Error(err as string)
    }

    return result
}
